enum MarketCodeEnum {
  EASTERN_EUROPE = 'easterneurope',
  EAST_MED = 'eastmed',
  TURKEY = 'tr',
}

export { MarketCodeEnum };
